var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('b-container',{staticClass:"bv-example-row",attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-sm-center"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }